import React, { useState } from "react";
import { useQuery } from "react-query";
import {
  getBills,
  getRewards,
  getTicketByBill,
} from "../services/game.service";
import { useNavigate } from "react-router-dom";

export default function HistoryPage() {
  const navigate = useNavigate();
  const [skip, setSkip] = useState(0);
  const limit = 10;

  const { data, isLoading, isFetching, refetch } = useQuery(
    ["get-rewards", skip],
    async () => {
      const resp = await getRewards({ limit, skip });
      return resp;
    },
    { keepPreviousData: true }
  );

  const [expandedBills, setExpandedBills] = useState<Record<string, boolean>>(
    {}
  );
  const [ticketsByBill, setTicketsByBill] = useState<Record<string, any[]>>({});
  const [loadingBills, setLoadingBills] = useState<Record<string, boolean>>({});

  // normalize different possible API shapes
  // let rewardsList: any[] = [];
  // if (data) {
  //   if (Array.isArray(data.bills)) rewardsList = data.bills;
  //   else if (Array.isArray((data.bills as any).data))
  //     rewardsList = (data.bills as any).data;
  //   else if (Array.isArray((data.bills as any).items))
  //     rewardsList = (data.bills as any).items;
  //   else if (Array.isArray((data.bills as any).bills))
  //     rewardsList = (data.bills as any).bills;
  //   else rewardsList = [];
  // }

  const toggleExpand = async (bill: any) => {
    const id = bill._id ?? bill.id ?? bill.billId ?? "-";
    const currently = !!expandedBills[id];
    const newExpanded = { ...expandedBills, [id]: !currently };
    setExpandedBills(newExpanded);

    if (!currently && !ticketsByBill[id]) {
      // if tickets already present in bill, use them
      if (Array.isArray(bill.tickets) && bill.tickets.length > 0) {
        setTicketsByBill((s) => ({ ...s, [id]: bill.tickets }));
        return;
      }

      // otherwise fetch tickets for this bill
      setLoadingBills((s) => ({ ...s, [id]: true }));
      try {
        const resp = await getTicketByBill({ billId: id });
        // normalize possible shapes
        let tickets: any[] = [];
        if (Array.isArray(resp)) tickets = resp;
        else if (Array.isArray(resp.tickets)) tickets = resp.tickets;
        else if (Array.isArray(resp.data)) tickets = resp.data;
        else if (Array.isArray(resp.items)) tickets = resp.items;
        setTicketsByBill((s) => ({ ...s, [id]: tickets }));
      } catch (err) {
        console.error("Failed to load tickets for bill", id, err);
        setTicketsByBill((s) => ({ ...s, [id]: [] }));
      } finally {
        setLoadingBills((s) => ({ ...s, [id]: false }));
      }
    }
  };

  const renderTicketPill = (ticket: any) => {
    const used = ticket.isUsed || false;
    const expired = ticket.isExpired || false;
    const style: React.CSSProperties = {
      display: "inline-block",
      padding: "6px 8px",
      borderRadius: 8,
      margin: "4px 6px 4px 0",
      background: used ? "#f0f0f0" : expired ? "#ffecec" : "#e6f9f0",
      color: used ? "#888" : expired ? "#d9534f" : "#126643",
      border: "1px solid " + (used ? "#eee" : expired ? "#f5c6cb" : "#d4f2df"),
      minWidth: 48,
      textAlign: "center",
      fontWeight: 500,
      fontSize: 12,
    };
    return (
      <div key={ticket._id ?? ticket.id ?? ticket.ticketNumber} style={style}>
        <div style={{ fontWeight: "bold" }}>{ticket.ticketNumber ?? "-"}</div>
        <div style={{ fontSize: 11, color: "#666" }}>
          {ticket.ticketLevel ?? ""}
        </div>
      </div>
    );
  };

  return (
    <div className="max-h-screen min-h-screen bg-[#FFF0F5] overflow-auto">
      <div className="grid mb-2">
        <div
          style={{
            background:
              "url('/images/background_header.png') no-repeat center top",
            backgroundSize: "cover",
            backgroundPosition: "bottom center",
            aspectRatio: "393/223",
            position: "relative",
          }}
        >
          {/* reward */}
          <div className="absolute bottom-[23%] right-0 left-0 w-full pl-[6%] text-center text-[#7B0B21] font-extrabold text-[18px]">
            {(data?.totalReward || 0).toLocaleString()}
          </div>

          <div
            onClick={() => navigate(-1)}
            className="absolute top-[4%] left-[4%] bg-transparent w-[10%] aspect-square font-bold text-[24px] cursor-pointer"
          ></div>
        </div>
      </div>

      <div className="p-[14px]">
        <div>
          {isLoading ? (
            <div style={{ textAlign: "center", color: "#888" }}>Loading...</div>
          ) : data?.bills?.length === 0 ? (
            <div style={{ textAlign: "center", color: "#888", fontSize: 16 }}>
              ບໍ່ມີປະຫວັດການຊື້ສະຫລາກ
            </div>
          ) : (
            <div>
              {data?.bills?.map((bill: any) => {
                const id = bill._id ?? bill.id ?? bill.billId ?? "-";
                const createdAt =
                  bill.createdAt ?? bill.date ?? bill.created ?? null;
                const dateStr = createdAt
                  ? new Date(createdAt).toLocaleDateString()
                  : "-";
                // const ticketCount =
                //   (bill.tickets && bill.tickets.length) ||
                //   (bill.selectTicketNumbers &&
                //     bill.selectTicketNumbers.length) ||
                //   bill.count ||
                //   "-";
                // const isExpanded = !!expandedBills[id];
                // const tickets =
                //   ticketsByBill[id] ??
                //   (Array.isArray(bill.tickets) ? bill.tickets : undefined);
                // const loading = !!loadingBills[id];

                const rewardPoint = (bill?.reward || 0).toLocaleString();

                return (
                  // <div
                  //   key={id}
                  //   style={{
                  //     borderRadius: 24,
                  //     overflow: "hidden",
                  //     border: "2px solid #D14877",
                  //     boxShadow: "0 2px 8px rgba(214,80,114,0.08)",
                  //     marginBottom: 12,
                  //     background: "#f4f4f4",
                  //     display: "flex",
                  //     flexDirection: "column",
                  //     position: "relative",
                  //   }}
                  // >
                  //   {/* Top content */}
                  //   <div
                  //     style={{
                  //       display: "flex",
                  //       padding: 12,
                  //       alignItems: "center",
                  //       gap: 12,
                  //     }}
                  //   >
                  //     <div>
                  //       <img
                  //         src="/images/scratch-icon.png"
                  //         alt="scratch"
                  //         style={{
                  //           width: 64,
                  //           height: 64,
                  //           objectFit: "contain",
                  //         }}
                  //       />
                  //     </div>

                  //     <div style={{ flex: 1 }}>
                  //       <div className="text-[24px] font-extrabold">
                  //         ເກມຈົກສະຫຼາກ
                  //       </div>
                  //       <div style={{ color: "#666" }}>
                  //         {bill.description ?? id}
                  //       </div>
                  //     </div>

                  //     <div className="absolute right-4 top-4">
                  //       <div style={{ color: "#999", fontSize: 12 }}>
                  //         {dateStr}
                  //       </div>
                  //     </div>
                  //   </div>

                  //   {/* Expanded tickets */}

                  //   <div style={{ padding: "0 12px 12px 12px" }}>
                  //     {loading ? (
                  //       <div style={{ color: "#888" }}>ກຳລັງໂຫຼດເລກບັດ...</div>
                  //     ) : tickets && tickets.length > 0 ? (
                  //       <div
                  //         style={{
                  //           display: "flex",
                  //           flexWrap: "wrap",
                  //           marginTop: 6,
                  //         }}
                  //       >
                  //         {tickets.map((t: any) => renderTicketPill(t))}
                  //       </div>
                  //     ) : (
                  //       <div style={{ color: "#888", marginTop: 6 }}>
                  //         ບໍ່ພົບເລກບັດ
                  //       </div>
                  //     )}
                  //   </div>

                  //   {/* Bottom gradient bar */}
                  //   <div
                  //     style={{
                  //       marginTop: 8,
                  //       padding: "12px 16px",
                  //       background:
                  //         "linear-gradient(180deg,#EF5E8F 0%,#F7A8BE 100%)",
                  //       display: "flex",
                  //       justifyContent: "space-between",
                  //       alignItems: "center",
                  //       color: "#fff",
                  //     }}
                  //   >
                  //     <div className="flex-1" />
                  //     <div style={{ display: "flex", alignItems: "center" }}>
                  //       <div className="text-[#2D2D2D]">ເງິນລາງວັນ:</div>
                  //       <div
                  //         style={{
                  //           width: 28,
                  //           height: 28,
                  //           borderRadius: 14,
                  //           background: "#fff",
                  //           display: "flex",
                  //           alignItems: "center",
                  //           justifyContent: "center",
                  //           marginRight: 8,
                  //         }}
                  //       >
                  //         <div
                  //           style={{
                  //             width: 14,
                  //             height: 14,
                  //             borderRadius: 7,
                  //             background: "#1e90ff",
                  //           }}
                  //         />
                  //       </div>
                  //       <div
                  //         style={{ fontWeight: 700, fontSize: 16 }}
                  //         className="text-[#7B0B21]"
                  //       >
                  //         {(bill.spendToken ??
                  //           bill.ticketsCount ??
                  //           ticketCount) ||
                  //           "-"}
                  //       </div>
                  //     </div>
                  //   </div>
                  // </div>
                  <div className="grid p-0 mb-2">
                    <div
                      style={{
                        padding: 0,
                        aspectRatio: "348/96",
                        position: "relative",
                      }}
                    >
                      {/* date */}
                      <div className="absolute top-[15%] right-[5%] text-end z-10 text-[12px] text-[#666666] font-medium">
                        {dateStr}
                      </div>
                      {/* reward */}
                      <div className="absolute bottom-[1%] w-[16%] text-center right-[5%] z-10 text-[16px] text-[#7B0B21] font-extrabold">
                        {rewardPoint}
                      </div>
                      <img
                        src="/images/cardHistoryReward.png"
                        alt="cardHistoryReward"
                        className="absolute top-0 w-full left-0 right-0"
                      />
                    </div>
                  </div>
                );
              })}

              <div style={{ textAlign: "center", marginTop: 16 }}>
                {(isFetching || false) && (
                  <div style={{ color: "#888" }}>ກຳລັງໂຫຼດ...</div>
                )}
                {data?.bills.length >= limit && (
                  <button
                    onClick={() => setSkip((s) => s + limit)}
                    style={{
                      marginTop: 8,
                      background: "#D65072",
                      color: "#fff",
                      border: "none",
                      padding: "8px 12px",
                      borderRadius: 8,
                    }}
                  >
                    ເພີ່ມເຕີມ
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
